// oxlint-disable-next-line no-restricted-imports
import { useDispatch, useSelector, useStore } from "react-redux";
import { type AppDispatch, type RootState, type store } from "./store";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<typeof store>();
